export function parseJson(value, fallback = null) {
  if (value == null) {
    return fallback;
  }

  if (typeof value !== 'string') {
    return value;
  }

  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

export function parseJsonArray(value, fallback = []) {
  const parsed = parseJson(value, fallback);
  return Array.isArray(parsed) ? parsed : fallback;
}

export function parseJsonObject(value, fallback = {}) {
  const parsed = parseJson(value, fallback);

  if (!parsed || Array.isArray(parsed) || typeof parsed !== 'object') {
    return fallback;
  }

  return parsed;
}
